import { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";

const LifecycleDialog = ({
  open,
  record,
  entityLabel,
  onCancel,
  onConfirm,
  busy,
}) => {
  const retired = record?.lifecycleStatus === "RETIRED";
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (open) setReason("");
  }, [open, record]);

  const reasonTooShort = !retired && reason.trim().length < 3;

  return (
    <Dialog
      open={open}
      onClose={() => !busy && onCancel()}
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle sx={{ fontWeight: 600 }}>
        {retired ? `Reactivate ${entityLabel}?` : `Retire ${entityLabel}?`}
      </DialogTitle>

      <DialogContent dividers>
        <DialogContentText sx={{ fontSize: "0.9rem" }}>
          {retired ?
            <>
              "{record?.displayName}" will become selectable again in every
              hospital.
            </>
          : <>
              "{record?.displayName}" will stop being offered to hospitals. It
              is not deleted — existing records that reference it keep working.
            </>
          }
        </DialogContentText>

        {!retired && (
          <TextField
            label="Reason for retiring"
            required
            fullWidth
            size="small"
            multiline
            minRows={2}
            sx={{ mt: 2 }}
            value={reason}
            onChange={(event) => setReason(event.target.value)}
            helperText="Recorded against the master for audit."
          />
        )}
      </DialogContent>

      <DialogActions sx={{ padding: "1rem 1.5rem" }}>
        <Button onClick={onCancel} disabled={busy}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color={retired ? "success" : "warning"}
          disabled={busy || reasonTooShort}
          onClick={() =>
            onConfirm({
              lifecycleStatus: retired ? "ACTIVE" : "RETIRED",
              retiredReason: reason.trim(),
            })
          }
        >
          {retired ? "Reactivate" : "Retire"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LifecycleDialog;
